import "./style.css";
import { t } from "../../services/formatters";
import { Consenso } from "../Consenso";
import { useSession } from "../../hooks/useSession";

export const InformativeC5 = (props) => {
    const { read, update } = useSession();

    const scrollToNextElement = (destinationIdx = null) => {
        console.log(destinationIdx);
        let destinationNode = document.querySelector(".btn-txt-container");
        if (null != destinationIdx) {
            destinationNode = document.querySelectorAll(".tos-item-component")[destinationIdx];
        }
        destinationNode.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    };

    const job = read("tipoOccupazione");
    const isEditAndOccupazioneIsSet = props.isEdit === true && job;
    const startIndex = isEditAndOccupazioneIsSet ? -1 : 0;

    const getOccupationOptions = () => {
        const options = [
            {
                label: "Dipendente pubblico/statale",
                value: "2",
            },
            {
                label: "Dipendente SPA/SRL (+15 dipendenti)",
                value: "2",
            },
            {
                label: "Dipendente SPA/SRL (-15 dipendenti)",
                value: "2",
            },
            {
                label: "Dipendente SNC/SAS",
                value: "2",
            },
            {
                label: "Pensionato",
                value: "3",
            },
            {
                label: "Altro",
                value: "4",
            },
        ];

        if (!read("id_filiale_direct_c5")) {
            options.unshift({
                label: "Autonomo",
                value: "1",
            });
        }

        return options;
    };

    return (
        <div className="section tos-list-component">
            {false ? (
                ""
            ) : (
                <div className={`section white-box input-box-component ${props.isEdit ? "hidden" : ""}`} id="impiegoC5">
                    <h3>{t("c5_impiego")}</h3>
                    <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>
                    <Consenso
                        defaultValue={read("tipoOccupazione")}
                        onChange={(value) => {
                            update("tipoOccupazione", value);
                            scrollToNextElement(startIndex + 1);
                        }}
                        name="tipoOccupazione"
                        text={""}
                        showInfoIcon={false}
                        optionsList={getOccupationOptions()}
                    />
                </div>
            )}

            <div className="testiInformativa">
                <h3>{t("we_need_your_consent_title")}</h3>
                <p>
                    <b>
                        {t("we_need_your_consent_doc")}{" "}
                        <a href="../share/pdfsni/PRIVACY_FA.PDF" target="_blank" className="underline">
                            qui scaricabili
                        </a>
                    </b>
                    <br />
                    <br />
                </p>
                <p>{t("we_need_your_consent_2")}</p>
            </div>

            <div className={`section input-box-component`}>
                <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>
                <Consenso
                    defaultValue={read("privacyExtcommoffer")}
                    onChange={(value) => {
                        update("privacyExtcommoffer", value);
                        scrollToNextElement(startIndex + 2);
                    }}
                    showInfoIcon={false}
                    name="privacyExtcommoffer"
                    text={t("c5_tos_1")}
                    textPreview={t("c5_tos_1")}
                />
                <Consenso
                    defaultValue={read("privacyOtherservice")}
                    onChange={(value) => {
                        update("privacyOtherservice", value);
                        scrollToNextElement(startIndex + 3);
                    }}
                    showInfoIcon={false}
                    name="privacyOtherservice"
                    text={t("c5_tos_2")}
                    textPreview={t("c5_tos_2")}
                />
                <Consenso
                    defaultValue={read("privacyProfilazione")}
                    onChange={(value) => {
                        update("privacyProfilazione", value);
                    }}
                    showInfoIcon={false}
                    name="privacyProfilazione"
                    text={t("c5_tos_3")}
                    textPreview={t("c5_tos_3")}
                />
            </div>
        </div>
    );
};
